import { AutogenLayoutCustomerServiceMultiProfile } from "./autogen/AutogenLayoutCustomerServiceMultiProfile";
import { LMEUserSettings } from "@mcleod/general";
import { MultiProfilePlanningTabs } from "../MultiProfilePlanningTabs";
import { Component, DataSource, DataSourceRemoteDataChangeEvent, PanelProps, Tab } from "@mcleod/components";
import { CustomerService } from "./CustomerService";

export class CustomerServiceMultiProfile extends AutogenLayoutCustomerServiceMultiProfile {
    private userProfiles: string[] = [];

    onLoad(): void | Promise<void> {
        if (LMEUserSettings.get()?.csm_profile != null)
            this.userProfiles.push(LMEUserSettings.get().csm_profile);
        if (LMEUserSettings.get()?.csm_profile2 != null)
            this.userProfiles.push(LMEUserSettings.get().csm_profile2);
        if (LMEUserSettings.get()?.csm_profile3 != null)
            this.userProfiles.push(LMEUserSettings.get().csm_profile3);
        if (LMEUserSettings.get()?.csm_profile4 != null)
            this.userProfiles.push(LMEUserSettings.get().csm_profile4);

        new MultiProfilePlanningTabs({
            tabset: this.tabsetCustomerServiceProfiles,
            profileDataSource: this.sourceCsmProfile,
            mainLayoutName: "lme/dispatch/planning/csm/CustomerService",
            advancedFilterLayout: "lme/dispatch/planning/csm/CustomerServiceProfileFilter",
            startingProfiles: this.userProfiles,
            profileDescrFieldName: "descr",
            dataSourceToAddListener: this.sourceCustomerServiceMovements
        });
    }

    handleRemoteDataChange(event: DataSourceRemoteDataChangeEvent) {
        event.preventDefault();
        this.tabsetCustomerServiceProfiles.components.forEach((tab: Tab, index) => {
            tab.components.forEach((component: Component) => {
                if (component instanceof CustomerService) {
                    if ("lme/dispatch/planning/csm/customer-service-movements" === (event.target as DataSource).url) {
                        const dataSource = component.sourceCustomerServiceMovements;
                        dataSource.handleDataChange(event.change);
                    }
                }
            })
        })
    }

    // Override the main router's padding to get the vertical profile tabset to be flush with the edge of the screen
    getRouterProps(): Partial<PanelProps> {
        return { padding: 0 };
    }
}
